<template>
<div id="newsletter-type-subscriber-create">
  <h2>
    Edit Newsletter Type Subscriber
  </h2>

  <newsletter-type-nav
    :newsletterTypeId="relationships.newsletter_type.id"
    :newsletterTypeSubscriberId="newsletterTypeSubscriberId"
    v-if="id"
  ></newsletter-type-nav>

  <newsletter-type-subscriber-form
    :newsletterTypeId="newsletterTypeId"
    :newsletterTypeSubscriberId="newsletterTypeSubscriberId"
  ></newsletter-type-subscriber-form>
</div>
</template>

<script>
import NewsletterTypeNav from '@/components/NewsletterTypeNav'
import NewsletterTypeSubscriberForm from '@/components/NewsletterTypeSubscriberForm'

import NewsletterTypeSubscriberStore from '@/stores/NewsletterTypeSubscriberStore'

export default {
  data () {
    return NewsletterTypeSubscriberStore.state
  },

  components: {
    'newsletter-type-nav': NewsletterTypeNav,
    'newsletter-type-subscriber-form': NewsletterTypeSubscriberForm
  },

  props: [
    'newsletterTypeId', 'newsletterTypeSubscriberId'
  ]

}
</script>



// WEBPACK FOOTER //
// src/components/NewsletterTypeSubscriberEdit.vue